import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Member"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M13.9177 11.5389C16.4997 12.068 19.5033 13.7906 19.5033 18.7586C19.5033 20.0834 17.7578 20.0834 12.1043 20.0834C6.3804 20.0834 4.70518 20.0834 4.70518 18.7586C4.70518 13.8573 7.70652 12.0702 10.2908 11.5389C8.26648 10.4787 7.56828 8.02911 8.5453 6.04191C9.52231 4.05472 11.966 3.32564 13.8498 4.38592C15.7335 5.4462 16.502 7.89574 15.4547 9.81625C15.1033 10.612 14.5456 11.141 13.9177 11.5389Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.6",
  d: "M8.0767 11.4591C8.29694 11.3969 8.35317 11.1257 8.17042 10.9923C6.54909 9.81425 6.05238 7.62255 6.94037 5.81541C7.07157 5.54867 7.22855 5.30416 7.40896 5.0841C7.55891 4.90183 7.40427 4.63732 7.1606 4.65732C6.11096 4.74179 5.11988 5.35528 4.6138 6.38445C3.90623 7.82261 4.2811 9.55863 5.53693 10.5278C5.71031 10.6634 5.65876 10.9257 5.44321 10.9901C3.50558 11.5636 1.5 13.0907 1.5 16.6983C1.5 17.2518 1.85847 17.5185 2.84018 17.6497C2.99715 17.6697 3.14242 17.563 3.15882 17.4118C3.54541 13.6953 5.86494 12.0793 8.0767 11.4591Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.6",
  d: "M15.9233 11.4591C15.7031 11.3969 15.6468 11.1257 15.8296 10.9923C17.4509 9.81425 17.9476 7.62255 17.0596 5.81541C16.9284 5.54867 16.7714 5.30416 16.591 5.0841C16.4411 4.90183 16.5957 4.63732 16.8394 4.65732C17.889 4.74179 18.8801 5.35528 19.3862 6.38445C20.0938 7.82261 19.7189 9.55863 18.4631 10.5278C18.2897 10.6634 18.3412 10.9257 18.5568 10.9901C20.4944 11.5636 22.5 13.0907 22.5 16.6983C22.5 17.2518 22.1415 17.5185 21.1598 17.6497C21.0028 17.6697 20.8576 17.563 20.8412 17.4118C20.4546 13.6953 18.1351 12.0793 15.9233 11.4591Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var member = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { member as default };
